module.exports = __webpack_public_path__ + "img/klarna.89289b83.png";